var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.WarmReminder"),
        width: "500px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "show-close": false,
        top: "5vh",
        "custom-class": "details-view booking-result-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "14px", "padding-bottom": "5px" } },
          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_YdBookingResultTip")))]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "show-side-bar": false,
                "row-data": this.ydBookingResult.diffJobList || [],
                "min-height": "470px"
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: _vm.onGridReady
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "footer", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "notReplace" },
                  on: { click: _vm.onNotReplace }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NotReplace")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "confirmReplace" },
                  on: { click: _vm.onConfirmReplace }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmReplace")))]
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { no: "cancel" }, on: { click: _vm.onCancel } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Ignore")))]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }